import { QuillDelta } from './quizDelta'

export type QuizScreenState = 'loading' | 'question' | 'results' | 'error'

export type QuizProgressStatus = 'unanswered' | 'correct' | 'incorrect'

export interface QuizOption {
  id: string
  text: string
  text_delta?: QuillDelta | null
  explanation: string
  explanation_delta?: QuillDelta | null
}

export interface QuizQuestion {
  id: string
  concept: string
  prompt: string
  prompt_delta?: QuillDelta | null
  options: QuizOption[]
  correctOptionId: string
  explanation: string
  explanation_delta?: QuillDelta | null
}

export interface QuizQuestionAnswer {
  questionId: string
  firstSelectedOptionId: string
  selectedOptionId: string
  firstAttemptCorrect: boolean
  isResolved: boolean
}

export interface QuizResultRow {
  questionId: string
  prompt: string
  correctAnswer: string
  userAnswer: string
  isCorrect: boolean
  explanation: string
}

export interface QuizConceptSummary {
  strongConcepts: string[]
  weakConcepts: string[]
}

/** next_in_queue from POST .../ai-spaced-repetition-quiz/section/:id/submit */
export type AiSpacedRepetitionNextInQueue = {
  student_book_subchapter_id?: string
  student_book_chapter_id?: string
  student_book_id?: string
  student_course_id?: string
  book_title?: string
  chapter_title?: string
  section_title?: string
  tag?: string
  tag_colour?: string
  next_quiz_scheduled_date?: string
  previous_five_quiz_average?: number
  proficiency_level?: number
}

export type AiSpacedRepetitionSubmitResponse = {
  next_in_queue?: AiSpacedRepetitionNextInQueue | null
  previous_five_quiz_average?: number
  proficiency_level?: number
  days_until_next_quiz?: number
  course_quizzes_due_today?: number
  chapter_quizzes_due_today?: number
  srq_red_dots_visible?: boolean
  section_quiz_due_today?: boolean
}

/** PATCH .../ai-spaced-repetition-quiz/section/:id/srq-red-dots */
export type AiSpacedRepetitionRedDotsPayload = {
  visible: boolean
  timezone: string
}

export type AiSpacedRepetitionRedDotsResponse = {
  srq_red_dots_visible?: boolean
  srq_red_dots_effective?: boolean
  course_srq_red_dots_visible?: boolean
  chapter_srq_red_dots_visible?: boolean
  course_quizzes_due_today?: number
}

export const getNextInQueueSubchapterId = (
  submitResponse?: AiSpacedRepetitionSubmitResponse | null
): string => submitResponse?.next_in_queue?.student_book_subchapter_id ?? ''
